import React, { useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';
import { Guardian } from '@xaamin/guardian';

import ReporteFacturacionXmlStorageList from './components/ReporteFacturacionXmlStorageList';
import ReporteFacturacionXmlStorageSearch from './components/ReporteFacturacionXmlStorageSearch';
import ReporteFacturacionXmlStorageDownload from './components/ReporteFacturacionXmlStorageDownload';

const ReporteFacturacionStorage = (props) => {
  useEffect(() => {
    window.setAppTitle('Facturación Almacenamiento');
  }, []);

  const handleOnRowClick = (data) => {
    // TODO sin detalle
  };

  return (
    <div>
      <Row>
        <Col
          sm="auto"
          md="9"
          className="mb-2"
        >
          <ReporteFacturacionXmlStorageSearch />
        </Col>

        {Guardian.allows('reporte.hits.por.pac.descargar') && (
          <Col className="text-right">{<ReporteFacturacionXmlStorageDownload />}</Col>
        )}
      </Row>

      <ReporteFacturacionXmlStorageList onRowClick={handleOnRowClick} />
    </div>
  );
};

export default ReporteFacturacionStorage;
